<template>
    <svg
        id="svg573"
        height="682.66669"
        version="1.1"
        viewBox="0 0 682.66669 682.66669"
        width="682.66669"
        xml:space="preserve"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:svg="http://www.w3.org/2000/svg">
        <defs id="defs577">
            <clipPath
                id="clipPath587"
                clipPathUnits="userSpaceOnUse">
                <path
                    id="path585"
                    d="M 0,512 H 512 V 0 H 0 Z" />
            </clipPath>
        </defs>
        <g
            id="g579"
            transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)">
            <g id="g581">
                <g
                    id="g583"
                    clip-path="url(#clipPath587)">
                    <g
                        id="g589"
                        transform="translate(467,45)">
                        <path
                            id="path591"
                            d="m 0,0 h -422 c -16.568,0 -30,13.431 -30,30 v 302 c 0,16.569 13.432,30 30,30 H 0 c 16.568,0 30,-13.431 30,-30 V 30 C 30,13.431 16.568,0 0,0 Z"
                            stroke="currentColor"
                            style="fill: none; stroke-width: 30; stroke-linecap: round; stroke-linejoin: round; stroke-miterlimit: 10; stroke-dasharray: none; stroke-opacity: 1" />
                    </g>
                    <g
                        id="g593"
                        transform="translate(105,15)">
                        <path
                            id="path595"
                            d="M 0,0 V 30"
                            stroke="currentColor"
                            style="fill: none; stroke-width: 30; stroke-linecap: round; stroke-linejoin: round; stroke-miterlimit: 10; stroke-dasharray: none; stroke-opacity: 1" />
                    </g>
                    <g
                        id="g597"
                        transform="translate(407,15)">
                        <path
                            id="path599"
                            d="M 0,0 V 30"
                            stroke="currentColor"
                            style="fill: none; stroke-width: 30; stroke-linecap: round; stroke-linejoin: round; stroke-miterlimit: 10; stroke-dasharray: none; stroke-opacity: 1" />
                    </g>
                    <path
                        id="path601"
                        d="M 377,105 H 75 v 242 h 302 z"
                        stroke="currentColor"
                        style="fill: none; stroke-width: 30; stroke-linecap: round; stroke-linejoin: round; stroke-miterlimit: 10; stroke-dasharray: none; stroke-opacity: 1" />
                    <g
                        id="g603"
                        transform="translate(452,316.9998)">
                        <path
                            id="path605"
                            d="m 0,0 c 0,-8.284 -6.716,-15 -15,-15 -8.284,0 -15,6.716 -15,15 0,8.284 6.716,15 15,15 C -6.716,15 0,8.284 0,0"
                            fill="currentColor"
                            style="fill-opacity: 1; fill-rule: nonzero; stroke: none" />
                    </g>
                    <g
                        id="g607"
                        transform="translate(452,256.9998)">
                        <path
                            id="path609"
                            d="m 0,0 c 0,-8.284 -6.716,-15 -15,-15 -8.284,0 -15,6.716 -15,15 0,8.284 6.716,15 15,15 C -6.716,15 0,8.284 0,0"
                            fill="currentColor"
                            style="fill-opacity: 1; fill-rule: nonzero; stroke: none" />
                    </g>
                    <g
                        id="g611"
                        transform="translate(437,135)">
                        <path
                            id="path613"
                            d="M 0,0 V 62"
                            stroke="currentColor"
                            style="fill: none; stroke-width: 30; stroke-linecap: round; stroke-linejoin: round; stroke-miterlimit: 10; stroke-dasharray: none; stroke-opacity: 1" />
                    </g>
                    <g
                        id="g615"
                        transform="translate(166,497)">
                        <path
                            id="path617"
                            d="M 0,0 90,-90 180,0"
                            stroke="currentColor"
                            style="fill: none; stroke-width: 30; stroke-linecap: round; stroke-linejoin: round; stroke-miterlimit: 10; stroke-dasharray: none; stroke-opacity: 1" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
